import { render } from "./required-change-password-msg-box.vue?vue&type=template&id=1f52d369&scoped=true&ts=true"
import script from "./required-change-password-msg-box.vue?vue&type=script&lang=ts"
export * from "./required-change-password-msg-box.vue?vue&type=script&lang=ts"

import "./required-change-password-msg-box.vue?vue&type=style&index=0&id=1f52d369&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f52d369"]])

export default __exports__